import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { PositionStyle } from "@insite/mobius/Popover";
import { InputStyle, TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ArrowRightWhiteIcon from "@tCentro/Icons/ArrowRightWhiteIcon";
import { useGetLink } from "@tCentro/Store/CustomLinksSelectors";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    bannerImage = "bannerImage",
    bannerTitle = "bannerTitle",
    bannerbtnLabel = "bannerbtnLabel",
    bannerCreateAccountbtnLabel = "bannerCreateAccountbtnLabel",
    bannerbtnLink = "bannerbtnLink",
    bannerCreateAccountbtnLink = "bannerCreateAccountbtnLink",
    loginTitle = "loginTitle",
    subheading = "subheading",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.bannerImage]: string;
        [fields.bannerTitle]: string;
        [fields.bannerbtnLabel]: string;
        [fields.bannerCreateAccountbtnLabel]: string;
        [fields.bannerbtnLink]: LinkFieldValue;
        [fields.bannerCreateAccountbtnLink]: LinkFieldValue;
        [fields.loginTitle]: string;
        [fields.subheading]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface CENNewHomePageBannerStyles {
    bannerContainer: InjectableCss;
    mainTitleStyles?: InjectableCss;
    mainUserNameTitleStyles?: InjectableCss;
    searchbarStyles?: TextFieldPresentationProps;
    buttonMainContainer?: InjectableCss;
    // loginStyles?: InjectableCss;
    // createAccountStyles?: InjectableCss;
    btnstyles?: InjectableCss;
    imageStyles?: InjectableCss;
    btnChildContainer?: InjectableCss;
    bannerContentContainer: InjectableCss;
    mainBannerBackgroundContainer?: InjectableCss;
    bannerTitleStyles?: InjectableCss;
    rightImgDiv?: InjectableCss;
    bannerSubheadingStyles?: InjectableCss;
}

export const cenNewHomepageBannerStyles: CENNewHomePageBannerStyles = {
    mainBannerBackgroundContainer: {
        css: css`
            background: linear-gradient(90deg, #266b40 44.06%, #2d804c 71.87%, #43687a 100%);
            margin-top: 40px;
        `,
    },
    bannerContainer: {
        css: css`
            max-width: 1800px;
            margin: auto;
            width: 100%;
            display: flex;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        align-items: center;
                        padding: 80px 20px 0px 20px;
                        gap: 20px;
                    `,
                    css`
                        flex-direction: column;
                        align-items: center;
                        padding: 80px 40px 0px 40px;
                        gap: 20px;
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },
    bannerContentContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            padding: 80px 0px 80px 50px;
            flex-wrap: wrap;
            width: 58.33%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        padding: 0px;
                        box-sizing: border-box;
                        align-items: center;
                    `,
                    css`
                        width: 100%;
                        padding: 0px;
                        box-sizing: border-box;
                        align-items: center;
                    `,
                    css`
                        padding: 40px 0px 40px 40px;
                        width: 75%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    imageStyles: {
        css: css`
            /* max-width: 554px; */
            width: 100%;
            position: relative;
            height: 100%;
            object-fit: contain;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 330px;
                        top: 7px;
                    `,
                    css`
                        max-width: 330px;
                        top: 7px;
                    `,
                    css`
                        /* max-width: 300px; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    bannerTitleStyles: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: 40px;
            font-weight: ${TYPOGRAPHY.weight.black};
            line-height: 48px;
            color: ${COLORS.white};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: ${TYPOGRAPHY.size.xxlarge};
                        line-height: 40px;
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        text-align: center;
                    `,
                    css`
                        font-size: ${TYPOGRAPHY.size.xxlarge};
                        line-height: 40px;
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        text-align: center;
                    `,
                    css``,
                    null,
                    null,
                ])}
        `,
    },

    bannerSubheadingStyles: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 24px;
            margin-top: 24px;
            margin-bottom: 0px !important;
            color: ${COLORS.white};
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: 18px !important;
                            text-align: center;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },

    btnstyles: {
        css: css`
            padding: 12px 24px;
            margin-top: 40px;
            background-color: white;
            border-radius: 24px;
            > span {
                font-size: ${TYPOGRAPHY.size.large};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                line-height: 24px;
                color: ${COLORS.secondary.base} !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: ${TYPOGRAPHY.size.base};
                        `,
                        css``,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
};

const styles = cenNewHomepageBannerStyles;
const CENAboutUsBanner: FC<Props> = ({ fields }) => {
    const { url } = useGetLink(fields.bannerbtnLink);
    const [leftDivHeight, setLeftDivHeight] = useState<number | undefined>(undefined);

    useEffect(() => {
        const handleResize = () => {
            const leftContentDiv = document.getElementById("leftContentDiv");
            if (leftContentDiv) {
                const height = leftContentDiv.getBoundingClientRect().height;
                setLeftDivHeight(height);
            }
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const rightImgDiv: any = {
        css: css`
            height: ${leftDivHeight}px;
            width: 41.67%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: auto;
                        width: 100%;
                        text-align: center;
                    `,
                    css`
                        height: auto;
                        width: 100%;
                        text-align: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    };
    return (
        <StyledWrapper {...styles.mainBannerBackgroundContainer}>
            <StyledWrapper {...styles.bannerContainer}>
                <StyledWrapper {...styles.bannerContentContainer} id="leftContentDiv">
                    {fields.bannerTitle && (
                        <Typography as="h1" {...styles.bannerTitleStyles}>
                            {fields.bannerTitle}
                        </Typography>
                    )}

                    {fields.subheading && (
                        <Typography variant="p" {...styles.bannerSubheadingStyles}>
                            {fields.subheading}
                        </Typography>
                    )}

                    {fields.bannerbtnLabel && (
                        <Link href={url} {...styles.btnstyles}>
                            {fields.bannerbtnLabel}
                        </Link>
                    )}
                </StyledWrapper>
                {fields.bannerImage && (
                    <StyledWrapper {...rightImgDiv}>
                        <Img src={fields.bannerImage} altText={fields.bannerTitle} {...styles.imageStyles} />
                    </StyledWrapper>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const CenAboutUsBanner: WidgetModule = {
    component: connect(mapStateToProps)(CENAboutUsBanner),
    definition: {
        group: "Common",
        displayName: "CEN New About Us Banner",
        fieldDefinitions: [
            {
                name: fields.bannerTitle,
                editorTemplate: "MultilineTextField",
                displayName: "Banner Heading",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.subheading,
                displayName: "Sub Heading",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.bannerImage,
                editorTemplate: "ImagePickerField",
                displayName: "Banner Image",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.bannerbtnLabel,
                editorTemplate: "TextField",
                displayName: "Primary Button Label",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.bannerbtnLink,
                displayName: "Primary Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
            },
        ],
    },
};
export default CenAboutUsBanner;
